import { Mapped } from "@omni/utils/context/mapped.context";
import { cn } from "@omni/utils/styles";
import { ReactNode } from "react";

import { ItemWrapper } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/AutocompleteItem/itemWrapper";
import { useResults } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/context/results.context";
import { CONTENT_PAGES_SOURCE_ID } from "@/components/Search/SearchBar/config/searchBar.config";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Items = ({ className, children }: Props) => {
    const { items } = useResults(CONTENT_PAGES_SOURCE_ID);

    return (
        <ul className={cn("tw:mb-0", className)}>
            <Mapped
                array={items}
                Wrapper={ItemWrapper}
            >
                {children}
            </Mapped>
        </ul>
    );
};
